<div class="d-flex flex-column gap-4">
    <adapt-styled-dashboard-element name="Progress"
                                    class="progress-container"
                                    [isCollapsible]="true"
                                    [background]="false">
        <div class="d-flex flex-wrap gap-3">
            @if (categoryChartData[0]; as categoryData) {
                <div class="total-progress-container flex-grow-1">
                    <ng-container *ngTemplateOutlet="pieChart; context: { $implicit: categoryData }"></ng-container>
                </div>
            }

            @if (categoryChartData.length > 1) {
                <div class="total-progress-container flex-grow-1 d-flex flex-wrap gap-3 justify-content-evenly">
                    @for (categoryData of categoryChartData; track categoryData.name; let first = $first) {
                        @if (!first) {
                            <ng-container *ngTemplateOutlet="pieChart; context: { $implicit: categoryData }"></ng-container>
                        }
                    }
                </div>
            }
        </div>
    </adapt-styled-dashboard-element>

    <div class="d-flex flex-column gap-4">
        @for (product of progressProducts; track product.progressProductId) {
            <adapt-styled-dashboard-element [name]="product.name"
                                            class="progress-product">
                <div class="d-flex flex-column gap-4">
                    @for (category of product.progressCategories; track category.progressCategoryId) {
                        <adapt-edit-progress-category [category]="category"
                                                      [canEdit]="canEdit"></adapt-edit-progress-category>
                    }
                </div>
            </adapt-styled-dashboard-element>
        }
    </div>
</div>

<ng-template #pieChart
             let-categoryData>
    <adapt-styled-dashboard-element [name]="categoryData.name"
                                    [nested]="true">
        <dx-pie-chart [dataSource]="categoryData.data"
                      [customizePoint]="customiseChartPoint"
                      [startAngle]="90"
                      resolveLabelOverlapping="shift"
                      sizeGroup="pieGroup"
                      class="d-flex justify-content-center"
                      (onDone)="updateChartDimensionAndSubscribeSizeChange($event)">
            <dxo-animation [enabled]="false"></dxo-animation>
            <dxo-legend orientation="horizontal"
                        itemTextPosition="right"
                        horizontalAlignment="center"
                        verticalAlignment="bottom"
                        [columnCount]="4"></dxo-legend>
            <dxi-series argumentField="label"
                        [minSegmentSize]="0"
                        valueField="percent">
                <dxo-label [visible]="true"
                           position="inside"
                           [customizeText]="customizeLabel">
                    <dxo-font [size]="11"></dxo-font>
                    <dxo-connector [visible]="true"
                                   [width]="0.5"></dxo-connector>
                </dxo-label>
            </dxi-series>
            <dxo-size [height]="200"
                      [width]="250"></dxo-size>
            <dxo-tooltip [enabled]="true"
                         [customizeTooltip]="customiseChartTooltip"></dxo-tooltip>
        </dx-pie-chart>
    </adapt-styled-dashboard-element>
</ng-template>
